export const MLP_CMS_PAGE_TYPES = {
  LANDING: 'landing',
  ORGANIZER: 'organizer',
  ORGANIZER_HUB: 'organizer-hub',
  CONSUMER: 'consumer',
  CORPORATE: 'corporate',
  SELL_TICKETS: 'sell-tickets',
  EVENT_TICKETING: 'event-ticketing',
  EVENTBRITE_VS: 'eventbrite-vs',
  HOW_TO_ORGANIZE: 'how-to-organize',
  FEATURES: 'features',
  FEATURE_ANNOUNCEMENT: 'feature-announcement',
} as const;

export const MLP_PAGE_TYPE_TO_BASE_PATH: Record<string, string> = {
  [MLP_CMS_PAGE_TYPES.ORGANIZER]: 'organizer',
  [MLP_CMS_PAGE_TYPES.LANDING]: 'l',
  [MLP_CMS_PAGE_TYPES.ORGANIZER_HUB]: 'organizer-hub',
  [MLP_CMS_PAGE_TYPES.CONSUMER]: 'consumer',
  [MLP_CMS_PAGE_TYPES.CORPORATE]: 'corporate',
  [MLP_CMS_PAGE_TYPES.SELL_TICKETS]: 'sell-tickets',
  [MLP_CMS_PAGE_TYPES.EVENT_TICKETING]: 'event-ticketing',
  [MLP_CMS_PAGE_TYPES.EVENTBRITE_VS]: 'eventbrite-vs',
  [MLP_CMS_PAGE_TYPES.HOW_TO_ORGANIZE]: 'how-to-organize',
  [MLP_CMS_PAGE_TYPES.FEATURES]: 'features',
  [MLP_CMS_PAGE_TYPES.FEATURE_ANNOUNCEMENT]: 'product-updates',
};

// Locale mappings for hreflang functionality
export const LOCALE_MAPPINGS: Record<string, string> = {
  'en-FI': 'fi', // Core supports en-FI and contentful supports fi
};

export const CONTENTFUL_LOCALE_MAPPINGS: Record<string, string> = {
  enUS: 'en-US',
  enCA: 'en-CA',
  enGB: 'en-GB',
  frFR: 'fr-FR',
  frCA: 'fr-CA',
  nlNL: 'nl-NL',
  enAU: 'en-AU',
  enHK: 'en-HK',
  enIE: 'en-IE',
  enNZ: 'en-NZ',
  enSG: 'en-SG',
  fi: 'fi',
  frCH: 'fr-CH',
  deDE: 'de-DE',
  deCH: 'de-CH',
  itIT: 'it-IT',
  ptPT: 'pt-PT',
  ptBR: 'pt-BR',
  esES: 'es-ES',
  esAR: 'es-AR',
  esCL: 'es-CL',
  esCO: 'es-CO',
  esMX: 'es-MX',
  esPE: 'es-PE',
  sv: 'sv',
  da: 'da',
};

// Mapping page type to cms collection name and page type name
export const PAGE_QUERY_CONFIGS = {
  [MLP_CMS_PAGE_TYPES.ORGANIZER]: {
    collectionName: 'globalOrganizerPageCollection',
    pageTypeName: 'OrganizerPage',
  },
  [MLP_CMS_PAGE_TYPES.LANDING]: {
    collectionName: 'globalLandingPageCollection',
    pageTypeName: 'LandingPage',
  },
  [MLP_CMS_PAGE_TYPES.ORGANIZER_HUB]: {
    collectionName: 'globalOrganizerHubPageCollection',
    // The organizer-hub collection stores OrganizerPage entries — there is no
    // OrganizerHubPage content type in Contentful, so the inline fragment must be OrganizerPage.
    pageTypeName: 'OrganizerPage',
  },
  [MLP_CMS_PAGE_TYPES.CONSUMER]: {
    collectionName: 'globalConsumerPageCollection',
    pageTypeName: 'ConsumerPage',
  },
  [MLP_CMS_PAGE_TYPES.CORPORATE]: {
    collectionName: 'globalCorporatePageCollection',
    pageTypeName: 'CorporatePage',
  },
  [MLP_CMS_PAGE_TYPES.SELL_TICKETS]: {
    collectionName: 'globalSellTicketsPageCollection',
    pageTypeName: 'SellTicketsPage',
  },
  [MLP_CMS_PAGE_TYPES.EVENT_TICKETING]: {
    collectionName: 'globalEventTicketingPageCollection',
    pageTypeName: 'EventTicketingPage',
  },
  [MLP_CMS_PAGE_TYPES.EVENTBRITE_VS]: {
    collectionName: 'globalEventbriteVsPageCollection',
    pageTypeName: 'EventbriteVsPage',
  },
  [MLP_CMS_PAGE_TYPES.HOW_TO_ORGANIZE]: {
    collectionName: 'globalHowToOrganizePageCollection',
    pageTypeName: 'HowToOrganizePage',
  },
  [MLP_CMS_PAGE_TYPES.FEATURES]: {
    collectionName: 'globalFeaturesPageCollection',
    pageTypeName: 'FeaturesPage',
  },
  [MLP_CMS_PAGE_TYPES.FEATURE_ANNOUNCEMENT]: {
    collectionName: 'featureAnnouncementListPageCollection',
    pageTypeName: 'FeatureAnnouncementListPage',
  },
} as const;

// EB Image Wordmark
export const EB_IMAGE_WORDMARK =
  'https://cdn.evbstatic.com/s3-build/perm_001/55d606/django/images/logos/eb_orange_on_white_1200x630.png';
